export const FAMILY_HEALTH_HISTORY_DATA_REQUEST =
  'FAMILY_HEALTH_HISTORY_DATA_REQUEST';
export const FAMILY_HEALTH_HISTORY_DATA_SUCCESS =
  'FAMILY_HEALTH_HISTORY_DATA_SUCCESS';
export const FAMILY_HEALTH_HISTORY_DATA_FAIL =
  'FAMILY_HEALTH_HISTORY_DATA_FAIL';
